<template>
  <div class="daily-panel">
    <div class="daily-header">
      销售区域日报
      <div class="week-button" @click="downloadArea">区域报表下载</div>
      <div class="day-button" @click="downloadPro">产品线报表下载</div>
    </div>
    <div class="daily-top" style="height:75px;">
      <div class="daily-status" style="color: #00CC88;">
        数据日期：{{ isLoading ? "加载中..." : dataTime }}
      </div>
      <div class="daily-status">
        <span class="daily-square color-green"></span>计划量
      </div>
      <div class="daily-status">
        <span class="daily-square color-blue"></span>订单量
      </div>
      <div class="daily-status">
        <span class="daily-square color-red"></span>结算量
      </div>
      <div class="daily-status">
        <span class="daily-ine daily-line-blue "></span>订单支持率
      </div>
      <div class="daily-status">
        <span class="daily-ine ldaily-line-orange"></span>计划完成率
      </div>
    </div>
    <div class="daily-total-content">
      <div class="daily-total">
        <div class="label-value" style="margin-left:98px;width:95px">
          <span class="ziti">分公司合计:</span>
        </div>
        <div class="label-value">
          <span class="ziti">计划量</span><br /><span
            class="ziti2"
            style="color:#00CC88;"
            >{{ areaTotal.plan }}</span
          >
        </div>
        <div class="label-value">
          <span class="ziti">订单量</span><br /><span
            class="ziti2"
            style="color:#409EFF;"
            >{{ areaTotal.order }}</span
          >
        </div>
        <div class="label-value">
          <span class="ziti">结算量</span><br /><span
            class="ziti2"
            style="color:#FF605F;"
            >{{ areaTotal.balance }}</span
          >
        </div>
        <div class="label-value">
          <span class="ziti">订单支持率</span><br /><span
            class="ziti2"
            style="color:#409EFF;"
            >{{ areaTotal.ocr }}</span
          >
        </div>
        <div class="label-value">
          <span class="ziti">计划完成率</span><br /><span
            class="ziti2"
            style="color:#FF605F;"
            >{{ areaTotal.bcr }}</span
          >
        </div>
      </div>
    </div>

    <div class="daily-map-content">
      <div class="left">
        <img
          class="mapPic"
          src="https://static.sprucesmart.com//dailydaily-map.png"
          alt=""
        />
        <img
          class="baoji-line"
          src="../../../assets/imgs/baoji-line.png"
          alt=""
        />
        <img
          class="changzhi-line"
          src="../../../assets/imgs/changzhi-line.png"
          alt=""
        />
        <img
          class="datong-line"
          src="../../../assets/imgs/datong-line.png"
          alt=""
        />
        <img
          class="hanzhong-line"
          src="../../../assets/imgs/hanzhong-line.png"
          alt=""
        />
        <img
          class="taiyuan-line"
          src="../../../assets/imgs/taiyuan-line.png"
          alt=""
        />
        <img
          class="weinan-line"
          src="../../../assets/imgs/weinan-line.png"
          alt=""
        />
        <img
          class="xian-line"
          src="../../../assets/imgs/xian-line.png"
          alt=""
        />
        <img
          class="xianyang-line"
          src="../../../assets/imgs/xianyang-line.png"
          alt=""
        />
        <img
          class="yanan-line"
          src="../../../assets/imgs/yanan-line.png"
          alt=""
        />
        <img
          class="yuncheng-line"
          src="../../../assets/imgs/yuncheng-line.png"
          alt=""
        />
        <div class="baoji-text">
          宝鸡<span>（{{ parseInt(baoji * 100) }}%）</span>
        </div>
        <div class="changzhi-text">
          长治<span>（{{ parseInt(changzhi * 100) }}%）</span>
        </div>
        <div class="datong-text">
          大同<span>（{{ parseInt(datong * 100) }}%）</span>
        </div>
        <div class="hanzhong-text">
          汉中<span>（{{ parseInt(hanzhong * 100) }}%）</span>
        </div>
        <div class="taiyuan-text">
          太原<span>（{{ parseInt(taiyuan * 100) }}%）</span>
        </div>
        <div class="weinan-text">
          渭南<span>（{{ parseInt(weinan * 100) }}%）</span>
        </div>
        <div class="xian-text">
          西安<span>（{{ parseInt(xian * 100) }}%）</span>
        </div>
        <div class="xianyang-text">
          咸阳<span>（{{ parseInt(xianyang * 100) }}%）</span>
        </div>
        <div class="yanan-text">
          延安<span>（{{ parseInt(yanan * 100) }}%）</span>
        </div>
        <div class="yuncheng-text">
          运城<span>（{{ parseInt(yuncheng * 100) }}%）</span>
        </div>
      </div>
      <div class="right">
        <div style="width: 672px;height:251px">
          <div class="area">
            <div class="area-square baoji-color"></div>
            <div class="area-text">宝鸡区域</div>
          </div>
          <div class="area">
            <div class="area-square changzhi-color"></div>
            <div class="area-text">长治区域</div>
          </div>
          <div class="area">
            <div class="area-square datong-color"></div>
            <div class="area-text">大同区域</div>
          </div>
          <div class="area">
            <div class="area-square hanzhong-color"></div>
            <div class="area-text">汉中区域</div>
          </div>
          <div class="area">
            <div class="area-square taiyuan-color"></div>
            <div class="area-text">太原区域</div>
          </div>
          <div class="area">
            <div class="area-square weinan-color"></div>
            <div class="area-text">渭南区域</div>
          </div>
          <div class="area">
            <div class="area-square xian-color"></div>
            <div class="area-text">西安区域</div>
          </div>
          <div class="area">
            <div class="area-square xianyang-color"></div>
            <div class="area-text">咸阳区域</div>
          </div>
          <div class="area">
            <div class="area-square yanan-color"></div>
            <div class="area-text">延安区域</div>
          </div>
          <div class="area">
            <div class="area-square yuncheng-color"></div>
            <div class="area-text">运城区域</div>
          </div>
        </div>
        <div style="width: 672px;height:251px">
          <div class="cell">
            <a-progress
              class="cell-persent"
              type="circle"
              :percent="parseInt(neibuxitong * 100)"
              :width="70"
              strokeColor="#2461EF"
              :format="() => `${parseInt(neibuxitong * 100)} %`"
            />
            <div class="cell-text">内部系统</div>
          </div>
          <div class="cell">
            <a-progress
              class="cell-persent"
              type="circle"
              :percent="parseInt(gongyeyou * 100)"
              :width="70"
              strokeColor="#2461EF"
              :format="() => `${parseInt(gongyeyou * 100)} %`"
            />
            <div class="cell-text">工业油</div>
          </div>
          <!-- <div class="cell">
            <a-progress class="cell-persent" type="circle" :percent="parseInt(shichangbu*100)" :width="70" strokeColor="#2461EF" :format="() => `${parseInt(shichangbu * 100)} %`"/>
            <div class="cell-text">市场部</div>
          </div> -->
          <div class="cell">
            <a-progress
              class="cell-persent"
              type="circle"
              :percent="parseInt(qifubu * 100)"
              :width="70"
              strokeColor="#2461EF"
              :format="() => `${parseInt(qifubu * 100)} %`"
            />
            <div class="cell-text">汽服部</div>
          </div>
          <div class="cell">
            <a-progress
              class="cell-persent"
              type="circle"
              :percent="parseInt(jichuyou * 100)"
              :width="70"
              strokeColor="#2461EF"
              :format="() => `${parseInt(jichuyou * 100)} %`"
            />
            <div class="cell-text">基础油</div>
          </div>
        </div>
      </div>
    </div>

    <div class="daily-content">
      <div class="charts">
        <div class="charts-title">区域合计</div>
        <div id="chart15" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">产品线合计</div>
        <div id="chart2020" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">高档汽油机油</div>
        <div id="chart1" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">高档柴油机油</div>
        <div id="chart2" class="charts-content"></div>
      </div>

      <div class="charts">
        <div class="charts-title">长寿命产品</div>
        <div id="chart3" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">车用油其他产品</div>
        <div id="chart4" class="charts-content"></div>
      </div>

      <div class="charts">
        <div class="charts-title">冷却液</div>
        <div id="chart5" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">两液</div>
        <div id="chart6" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">复合剂</div>
        <div id="chart8" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">新特产品</div>
        <div id="chart9" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">工业油其他产品</div>
        <div id="chart10" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">润滑脂</div>
        <div id="chart11" class="charts-content"></div>
      </div>

      <div class="charts">
        <div class="charts-title">金属加工油</div>
        <div id="chart12" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">特种油部</div>
        <div id="chart13" class="charts-content"></div>
      </div>
      <div class="charts">
        <div class="charts-title">基础油产品线</div>
        <div id="chart14" class="charts-content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Loading } from "element-ui";
// import json from "@/assets/json/new_xian_daily.json";
// import echarts from 'echarts'
import Cookie from "js-cookie";
import { Notification } from "element-ui";
export default {
  data() {
    return {
      areaTotal: {},
      timer: "",
      isLoading: true,
      dataTime: "",
      neimeng: 0,
      tianjin: 0,
      baoji: 0,
      changzhi: 0,
      datong: 0,
      hanzhong: 0,
      taiyuan: 0,
      weinan: 0,
      xian: 0,
      xianyang: 0,
      yanan: 0,
      yuncheng: 0,
      neibuxitong: 0,
      gongyeyou: 0,
      shichangbu: 0,
      qifubu: 0,
      jichuyou: 0,
      option: {
        color: [
          "#00A4E1",
          "#FE5500",
          "#7ddcb9",
          "#000000",
          "#ff0000",
          "#0000ff",
          "#fff",
        ],
        tooltip: {
          trigger: "axis",
          color: ["#ff0000", "#00ff00", "#0000ff"],
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "0",
          right: "0",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
            },
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            name: "/吨",
          },
          {
            type: "value",
            scale: true,
            name: "完成率：%",
            min: -100,
          },
        ],
        series: [
          {
            name: "计划量",
            type: "bar",
            yAxisIndex: 0,
            barGap: 0,
            itemStyle: {
              normal: {
                color: "#00CC88",
              },
            },
            //              label: {
            //                normal: {
            //                  show: true,
            //                  position: 'top'
            //                }
            //              },
            data: [],
          },
          {
            name: "订单量",
            type: "bar",
            barGap: 0,
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#409EFF",
              },
            },
            //              label: {
            //                normal: {
            //                  show: true,
            //                  position: 'top'
            //                }
            //              },
            data: [],
          },
          {
            name: "结算量",
            type: "bar",
            yAxisIndex: 0,
            itemStyle: {
              normal: {
                color: "#FF0000",
              },
            },
            //              label: {
            //                normal: {
            //                  show: true,
            //                  position: 'top'
            //                }
            //              },
            data: [],
          },
          {
            name: "订单支持率",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#409eff",
              },
            },
            lineStyle: {
              color: "#409eff",
            },
            type: "line",
            smooth: true,
            data: [],
          },
          {
            name: "计划完成率",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#ff0000",
              },
            },
            lineStyle: {
              color: "#ff0000",
            },
            type: "line",
            smooth: true,
            data: [],
          },
        ],
      },
    };
  },
  created() {
    this.isLoading = false;
    this.init();
    console.log("MD5", this.closeLoading);
  },
  methods: {
    change100Times(params) {
      for (let i = 0, len = params.length; i < len; i++) {
        params[i] *= 100;
        params[i] = parseFloat(params[i]).toFixed(1);
      }
      return params;
    },
    init() {
      console.log('this.axios.defaults.baseURL2',this.axios.defaults.baseURL2)
      this.axios
        .get(this.axios.defaults.baseURL2 + "daily/")
        .then((res) => {
          this.areaTotal = res.data.total;
          this.dataTime = res.data.last_date;
          this.isLoading = false;
          this.baoji = res.data.middle_map_data[0].baoji;
          this.changzhi = res.data.middle_map_data[0].changzhi;
          this.datong = res.data.middle_map_data[0].datong;
          this.hanzhong = res.data.middle_map_data[0].hanzhong;
          this.taiyuan = res.data.middle_map_data[0].taiyuan;
          this.weinan = res.data.middle_map_data[0].weinan;
          this.xian = res.data.middle_map_data[0].xian;
          this.xianyang = res.data.middle_map_data[0].xianyang;
          this.yanan = res.data.middle_map_data[0].yanan;
          this.yuncheng = res.data.middle_map_data[0].yuncheng;
          this.neibuxitong = res.data.middle_map_data[0].neibuxitong;
          this.gongyeyou = res.data.middle_map_data[0].gongyeyou;
          this.shichangbu = res.data.middle_map_data[0].shichangbu;
          this.qifubu = res.data.middle_map_data[0].qifubu;
          this.jichuyou = res.data.middle_map_data[0].tezhongyou;
          // this.$nextTick(() => {
          res.data.pl_data.forEach((item, index) => {
            // console.log('111', item)
            let tempOption = this.option;
            if (item.pl_type == 1) {
              tempOption.series[0].data = item.pl_plan;
              tempOption.series[1].data = item.pl_order;
              tempOption.series[2].data = item.pl_balance;
              tempOption.series[3].data = this.change100Times(item.pl_ocr);
              tempOption.series[4].data = this.change100Times(item.pl_bcr);
            } else {
              tempOption.series[0].data = [];
              tempOption.series[1].data = item.pl_order;
              tempOption.series[2].data = item.pl_balance;
              tempOption.series[3].data = [];
              tempOption.series[4].data = [];
            }
            // tempOption.series[0].data = item.pl_plan;
            // tempOption.series[1].data = item.pl_order;
            // tempOption.series[2].data = item.pl_balance;
            // tempOption.series[3].data = this.change100Times(item.pl_ocr);
            // tempOption.series[4].data = this.change100Times(item.pl_bcr);
            tempOption.xAxis[0].data = item.area_list;
            let myChart = this.$echarts.init(
              document.getElementById("chart" + item.pl_id)
            );
            myChart.setOption(tempOption);
          });
          // });
        })
        .catch((error) => {
          this.closeLoading();
          if (error.response.status == 403) {
            this.$router.push({
              name: "login",
            });
          }
        });
    },
    downloadArea() {
      window.location.href =
        this.axios.defaults.baseURL2 + "daily/" + "?download=1";
      // "https://xarh.sprucesmart.com/api/v5/?download=1";
    },
    downloadPro() {
      window.location.href =
        this.axios.defaults.baseURL2 + "daily/" + "?download=1";
      // "https://xarh.sprucesmart.com/api/v5/?download=1";
    },
  },
};
</script>
<style>
.daily-panel {
  width: 100%;
  height: 100%;
}
.daily-header {
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  font-size: 28px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(48, 48, 48, 1);
  line-height: 60px;
  text-align: center;
  position: relative;
}
.day-button {
  width: 150px;
  height: 38px;
  line-height: 38px;
  background-color: #e6a23c;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: absolute;
  right: 40px;
  top: 11px;
  cursor: default;
}
.week-button {
  width: 150px;
  height: 38px;
  line-height: 38px;
  background-color: #00cc88;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  position: absolute;
  right: 210px;
  top: 11px;
  cursor: default;
}
.daily-top {
  text-align: center;
  /* width: 1568px; */
  /* margin: 0 auto; */
}
.daily-status {
  display: inline-block;
  margin: 25px 80px 25px 0;
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 500;
  color: #303030;
}
.daily-total-content {
  width: 100%;
  padding: 20px;
}
.daily-total .label-name {
  font-size: 17px;
}

.daily-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 110px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(197, 197, 197, 1);
  text-align: center;
  padding: 0 100px;
}
.label-value {
  width: 90px;
  display: block;
  text-align: center;
}
.ziti {
  font-size: 18px;
}
.ziti2 {
  font-size: 36px;
  font-weight: bold;
}
.daily-square {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  margin-right: 8px;
}
.daily-ine {
  display: inline-block;
  width: 37px;
  height: 5px;
  position: relative;
  top: -2px;
  margin-right: 8px;
}
.daily-line-blue {
  background-image: url("~@/assets/imgs/blue-line.png");
  background-size: 100% 100%;
}
.daily-line-green {
  background-image: url("~@/assets/imgs/green-line.png");
  background-size: 100% 100%;
}
.ldaily-line-orange {
  background-image: url("~@/assets/imgs/orange-line.png");
  background-size: 100% 100%;
}
.color-green {
  background-color: #00cc88;
}
.color-blue {
  background-color: #409eff;
}
.color-red {
  background-color: red;
}
.daily-map-content {
  height: 579px;
  background-color: #ffffff;
}
.daily-map-content .left {
  float: left;
  width: 500px;
  height: 579px;
  position: relative;
}
.daily-map-content .left .mapPic {
  position: absolute;
  left: 138px;
  width: 100%;
  height: 100%;
}
.daily-map-content .left .baoji-line {
  display: inline-block;
  width: 110px;
  height: 33px;
  position: absolute;
  top: 349px;
  left: 119px;
  z-index: 10;
}
.daily-map-content .left .changzhi-line {
  display: inline-block;
  width: 44px;
  height: 33px;
  position: absolute;
  top: 260px;
  left: 563px;
  z-index: 10;
}
.datong-line {
  display: inline-block;
  width: 44px;
  height: 33px;
  position: absolute;
  top: 60px;
  left: 600px;
  z-index: 10;
}
.hanzhong-line {
  display: inline-block;
  width: 65px;
  height: 33px;
  position: absolute;
  top: 502px;
  left: 201px;
  z-index: 10;
}
/* 太原指示线 */
.taiyuan-line {
  display: inline-block;
  width: 92px;
  height: 33px;
  position: absolute;
  top: 150px;
  left: 528px;
  z-index: 10;
}
.weinan-line {
  display: inline-block;
  width: 80px;
  height: 33px;
  position: absolute;
  top: 392px;
  left: 377px;
  z-index: 10;
}
.xian-line {
  display: inline-block;
  width: 112px;
  height: 30px;
  position: absolute;
  top: 412px;
  left: 187px;
  z-index: 10;
}
.xianyang-line {
  display: inline-block;
  width: 80px;
  height: 30px;
  position: absolute;
  top: 336px;
  left: 236px;
  z-index: 10;
}
.yanan-line {
  display: inline-block;
  width: 80px;
  height: 10px;
  position: absolute;
  top: 289px;
  left: 289px;
  z-index: 10;
}
.yuncheng-line {
  display: inline-block;
  width: 38px;
  height: 30px;
  position: absolute;
  top: 343px;
  left: 457px;
  z-index: 10;
}
.daily-map-content .left .baoji-text {
  min-width: 100px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 500;
  color: #00ff30;
  position: absolute;
  top: 340px;
  left: 60px;
  z-index: 15;
}
.changzhi-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 281px;
  left: 612px;
  z-index: 15;
  color: #5a79fe;
}
.datong-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 80px;
  left: 652px;
  z-index: 15;
  color: #6ab4ff;
}
/* 汉中字体 */
.hanzhong-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 531px;
  left: 150px;
  z-index: 15;
  color: #3fffd4;
}
/* 太原字体 */
.taiyuan-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 142px;
  left: 623px;
  z-index: 15;
  color: #0084ff;
}
.weinan-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 420px;
  left: 444px;
  z-index: 15;
  color: #3fe362;
}
.xian-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 430px;
  left: 120px;
  z-index: 15;
  color: #9afc74;
}
.xianyang-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 310px;
  left: 200px;
  z-index: 15;
  color: #0fc74b;
}
.yanan-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 280px;
  left: 220px;
  z-index: 15;
  color: #74fcb1;
}
.yuncheng-text {
  min-width: 100px;
  height: 28px;
  position: absolute;
  top: 364px;
  left: 498px;
  z-index: 15;
  color: #a6d4ff;
}
.daily-map-content .right {
  width: 616px;
  height: 579px;
  float: right;
  position: relative;
  right: 50px;
}
.daily-map-content .right .area {
  width: 24%;
  height: 24px;
  line-height: 24px;
  overflow: hidden;
  float: left;
  margin-top: 45px;
}
.daily-map-content .right .area .area-square {
  width: 24px;
  height: 24px;
  float: left;
  margin-right: 10px;
}
.daily-map-content .left .nmg-text span {
  font-size: 16px;
}

.daily-map-content .right .area .baoji-color {
  background-color: #00ff30;
}
.daily-map-content .right .area .changzhi-color {
  background-color: #5a79fe;
}
.daily-map-content .right .area .datong-color {
  background-color: #6ab4ff;
}
.daily-map-content .right .area .hanzhong-color {
  background-color: #3fffd4;
}
.daily-map-content .right .area .taiyuan-color {
  background-color: #0084ff;
}
.daily-map-content .right .area .weinan-color {
  background-color: #3fe362;
}
.daily-map-content .right .area .xian-color {
  background-color: #9afc74;
}
.daily-map-content .right .area .xianyang-color {
  background-color: #0fc74b;
}
.daily-map-content .right .area .yanan-color {
  background-color: #74fcb1;
}
.daily-map-content .right .area .yuncheng-color {
  background-color: #a6d4ff;
}
.daily-map-content .right .area .area-text {
  height: 24px;
  line-height: 24px;
  float: left;
  font-size: 14px;
  font-family: PingFangSC;
  font-weight: 500;
  color: #2461ef;
}
.daily-map-content .right .cell {
  width: 110px;
  margin-top: 75px;
  margin-right: 20px;
  float: left;
}
.daily-map-content .right .cell .cell-persent {
  display: inline-block;
  margin: 0 15px 30px;
}
.daily-map-content .right .cell .cell-text {
  width: 100%;
  height: 18px;
  line-height: 18px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  text-align: center;
}
.daily-content {
  width: 100%;
  height: 100%;
  text-align: center;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
}

.charts {
  width: 725px;
  height: 450px;
  text-align: center;
  margin: 0 auto;
  background-color: #ffffff;
  border: 1px solid #e1e1e1;
  margin-bottom: 20px;
}
.charts-title {
  width: 100%;
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #e1e1e1;
  font-size: 18px;
  font-family: PingFangSC;
  font-weight: 500;
  color: #303030;
  padding-left: 10px;
}
.charts-content {
  width: 725px;
  height: 400px;
  padding: 10px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/bigDataBoard/SellAreaDay.vue